import { internalFetch } from '../utils/fetchHelper';

export interface IAutomaticSurchargeRule {
  pricingItemId: number;
  code: string;
  name: string;
  enabled: boolean;
  countryCode: string | null;
  stateCode: string | null;
  tenantEnabled: boolean | null;
  effectiveEnabled: boolean;
}
export interface ISaveAutomaticSurcharge {
  pricingItemId: number;
  enabled: boolean;
  countryCode: string | null;
  stateCode: string | null;
}
const base = () => `${import.meta.env.VITE_BACKEND_API_URL}/p`;
export const getAutomaticSurcharges = (
  controller: AbortController
): Promise<IAutomaticSurchargeRule[]> =>
  internalFetch(
    `${base()}/globalSettings/automaticSurcharges`,
    'GET',
    controller
  );
export const saveAutomaticSurcharge = (
  controller: AbortController,
  rule: ISaveAutomaticSurcharge
): Promise<void> =>
  internalFetch(
    `${base()}/globalSettings/automaticSurcharges`,
    'PUT',
    controller,
    JSON.stringify(rule)
  );
export const getTenantSurcharges = (
  controller: AbortController
): Promise<IAutomaticSurchargeRule[]> =>
  internalFetch(`${base()}/tenantSurcharges`, 'GET', controller);
export const saveTenantSurcharge = (
  controller: AbortController,
  pricingItemId: number,
  enabled: boolean | null
): Promise<void> =>
  internalFetch(
    `${base()}/tenantSurcharges`,
    'PUT',
    controller,
    JSON.stringify({ pricingItemId, enabled })
  );
